<template>
  <div class="container-size bg-success">
    <div class="s-card">
      <div class="text-center">
        <img src="/img/other/ticket_success.png" style="width: 100%;" />
      </div>

      <div class="text-center font-weight-bold mt-10">
        <p style="font-size: 24px; max-width: 410px; margin: auto;">
          {{ $t('successEvent.title') }}
        </p>
      </div>

      <div class="text-center mt-5 mb-10" v-html="$t('successEvent.description')"></div>

      <div class="text-center mt-5 d-flex" style="justify-content: center;">
        <Button :name="$t('successEvent.button')" @click="goToHomePage" width="270px" height="47px" />
      </div>

      <div class="text-center mt-10 mb-2">
        <span style="font-size: 1rem">{{ $t('successEvent.contactInfo') }}</span>
      </div>

      <div v-if="mobileView">
        <span>{{ $t('successEvent.whatsappLabel') }}</span>
        <p><b>{{ $t('successEvent.whatsappValue') }}</b></p>
      </div>

      <table style="text-align: left;" v-else>
        <tr>
          <th>{{ $t('successEvent.whatsappLabel') }}</th>
          <td>: <b>{{ $t('successEvent.whatsappValue') }}</b></td>
        </tr>
      </table>
    </div>
  </div>
</template>


<script>
import Button from '../../components/others/Button.vue';
export default {
  components: {
    Button
  },
  data() {
    return {
      mobileView: false
    }
  },
  methods: {
    goToHomePage() {
      this.$router.push("/event")
    },
  },
  mounted() {
    this.mobileView = window.innerWidth <= 990;
  }
};
</script>
<style scoped>
.s-card {
  padding: 40px 60px;
  width: 40%;
  margin: auto;
  background-color: white;
  border-radius: 36px;
}

.bg-success {
  background-color: rgb(243, 240, 240);
  padding: 30px 0;
}

@media screen and (max-width: 900px) {
  .s-card {
    width: 90%;
    padding: 30px 18px;
  }
}
</style>